export default {
    actionRequested: 'Action Requested',
    cancelationPending: 'Cancelation Pending',
    disputeApproved: 'Dispute Approved',
    disputeCanceled: 'Dispute Canceled',
    disputeCompleted: 'Dispute Completed',
    disputeDenied: 'Dispute Denied',
    disputeOpened: 'Dispute Opened',
    disputeUnderReview: 'Under Review',
    temporaryCredit: 'Temporary Credit'
};
//# sourceMappingURL=transactionStatus.js.map